import React, { useState } from "react";
import "./COC.css";
import moment from "moment";
import { apiCall } from "../api/apiUtil";
import { useNavigate } from "react-router-dom";
import {
	Row,
	Col,
	Button,
	Card,
	Table,
	Form,
	Container,
	Modal,
	Tabs,
	Tab,
} from "react-bootstrap";
import {
	FaTachometerAlt,
	FaCalendarAlt,
	FaUsers,
	FaUser,
	FaArrowRight,
	FaSpinner,
} from "react-icons/fa"; // Import Calendar Icon
import { FaCircleStop, FaCloudArrowDown, FaHand, FaBan } from "react-icons/fa6";

const LeadershipAccountability = () => {
    const [complianceId, setComplianceId] = useState(
            sessionStorage.getItem("Id")
    );
    const [isChecked, setIsChecked] = useState(false);
    const [globalId, setGlobalId] = useState(
        sessionStorage.getItem("globalCode")
    );
    const [year, setYear] = useState(sessionStorage.getItem("year"));
    const [month, setMonth] = useState(sessionStorage.getItem("month"));
    const [formData, setFormData] = useState({
        GlobalCode: sessionStorage.getItem("globalCode"),
        EmpCode: sessionStorage.getItem("globalCode"),
        Name: sessionStorage.getItem("userName"),
        Email: sessionStorage.getItem("userEmail"),
        Department: sessionStorage.getItem("departmentName"),
        Designation: sessionStorage.getItem("designationName"),
        StartDate: moment(sessionStorage.getItem("startDate")).format("YYYY-MM-DD"),
        EndDate: moment(sessionStorage.getItem("endDate")).format("YYYY-MM-DD"),
        Year: sessionStorage.getItem("year"),
        Month: sessionStorage.getItem("month"),
        Period: sessionStorage.getItem("period"),
        AcknowledgeMarked: true,
        // Signature: "",
        Date: moment().format("YYYY-MM-DD"),
        Place: sessionStorage.getItem("place"),
        CreatedOn: moment().format("YYYY-MM-DD HH:mm:ss"),
        Published: 0,
    });

    const navigate = useNavigate();

    const handleChange = (e) => {
		const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
	};

    const handleSubmit = async (e) => {        
		e.preventDefault();
		if (isChecked === false) {
			alert("Acceptance of Leadership Accountability compliance is required.");
			return;
		}

        console.log("Form Data:", JSON.stringify(formData));
        try {
            const response = await apiCall("/LeadershipAccountabilityForm/SaveLeadershipAccountability", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (response?.success) {
                alert(response?.message);
                navigate("/user-dashboard");
            } else {
                console.error("Failed to submit data");
            }
        } catch (error) {
            console.error("Error during form submission:", error);
        }
    };

    return (
		<div id="coc-form" className="d-flex flex-column min-vh-100">
			<form onSubmit={handleSubmit}>
                <h2 className="text-2xl font-bold text-center">
					Employee Self-Declaration Form
				</h2>
				<p className="text-center font-medium">
					Declaration of Leadership Accountability and Professional Responsibility
				</p>

                {/* Employee Info */}
				<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
					<div>
						<label className="font-semibold">
							<span style={{ color: "red" }}>*</span>Full Name:
						</label>
						<input
							type="text"
							name="Name"
							value={formData.Name}
							onChange={handleChange}
							className="w-full border p-2 rounded mb-4"
							required
							readOnly
						/>
					</div>
					<div>
						<label className="font-semibold">
							<span style={{ color: "red" }}>*</span>Employee ID:
						</label>
						<input
							type="text"
							name="GlobalCode"
							value={formData.GlobalCode}
							onChange={handleChange}
							className="w-full border p-2 rounded mb-4"
							required
							readOnly
						/>
					</div>
					<div>
						<label className="font-semibold">
							<span style={{ color: "red" }}>*</span>Designation:
						</label>
						<input
							type="text"
							name="Designation"
							value={formData.Designation}
							onChange={handleChange}
							className="w-full border p-2 rounded mb-4"
							required
							readOnly
						/>
					</div>
					<div>
						<label className="font-semibold">
							<span style={{ color: "red" }}>*</span>Department:
						</label>
						<input
							type="text"
							name="Department"
							value={formData.Department}
							onChange={handleChange}
							className="w-full border p-2 rounded mb-4"
							required
							readOnly
						/>
					</div>
				</div>
                
                <div>
                    <h3 className="text-xl font-semibold mt-6">
						Purpose:
					</h3>
                    <p>To reinforce a culture of integrity, transparency, ownership, and solution-oriented leadership across the organization.</p>

                    <p>I, the undersigned, holding a leadership position at Grade CG3 or above, acknowledge that leadership demands transparency, ownership, and decisive action. I hereby commit to the following principles of professional conduct:</p>
                    <ol className="list-disc list-inside space-y-1">
                        <li>
                            <b>Uncompromising Data Integrity & Transparency</b>
                            <p>
                                I commit to sharing accurate, complete, and timely information with peers and leadership. I
                                will not knowingly conceal, delay, misrepresent, or selectively present data to avoid scrutiny or
                                accountability. I understand that organizational effectiveness depends on a shared, honest
                                understanding of facts and realities.
                            </p>
                        </li>
                        <li>
                            <b>Radical Accountability (No Blame Culture)</b>
                            <p>
                                I accept full accountability for the outcomes, performance, and decisions of my team and
                                function. In the event of unmet objectives or failures, I will not deflect responsibility to external
                                factors, cross-functional dependencies, or team members. I acknowledge that, as a leader,
                                accountability ultimately rests with me.
                            </p>
                        </li>
                        <li>
                            <b>Solution-Oriented Mindset</b>
                            <p>
                                I commit to addressing challenges with a bias for action. When raising risks or issues, I will
                                endeavor to present viable solutions, recommendations, or corrective actions. I will act as an
                                owner and problem solver, not merely as a reporter or escalator of problems.                                
                            </p>
                        </li>
                        <li>
                            <b>Transparent Failure Analysis</b>
                            <p>
                                In the event of a setback or failure, I will ensure a candid and structured analysis focused on
                                root causes rather than individual fault. My focus will be on learning, corrective action, and
                                strengthening systems and processes to prevent recurrence.                                
                            </p>
                        </li>
                        <li>
                            <b>Ownership of the End-to-End Mission</b>
                            <p>
                                I recognize that my responsibility extends beyond my immediate role or function. I will take
                                ownership of the broader organizational mission, ensure alignment with enterprise priorities,
                                and proactively collaborate across functions to drive collective success.                                
                            </p>
                        </li>
                    </ol>
                    <h3 className="text-xl font-semibold mt-6">
						Affirmation:
					</h3>
                    <p className="affirmation-line-height">
                        <input
                            type="checkbox"
                            id="myCheckbox"
                            checked={isChecked}
                            onChange={() => setIsChecked(!isChecked)} style={{ marginTop: "15px" }}
                        />
                        I understand that leadership is not defined by position, but by responsibility and conduct. By
                        submitting this declaration, I affirm my commitment to lead by example, uphold the highest
                        standards of integrity, and own the outcomes of my decisions and actions—both positive and
                        adverse.
                    </p>
                </div> <br />

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
						<label className="font-semibold">
							<span style={{ color: "red" }}>*</span>Date:
						</label>
						<input
							type="date"
							name="Date"
							value={formData.Date}
							onChange={handleChange}
							className="w-full border p-2 rounded"
							required
							readOnly
						/>
					</div>
					<div>
						<label className="font-semibold">
							<span style={{ color: "red" }}>*</span>Place:
						</label>
						<input
							type="text"
							name="Place"
							value={formData.Place}
							onChange={handleChange}
							className="w-full border p-2 rounded"
							required
							readOnly
						/>
					</div>
					<div>
						<button
							type="submit"
							//   disabled={disableSubmitButton}
							className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
							style={{marginTop: "33px"}}
						>
							Declare
						</button>
					</div>
                </div>
            </form>
        </div>
    );
};

export default LeadershipAccountability;